/* eslint-disable react/display-name */
import React from 'react';
import styled from 'styled-components';

import Flex from 'components/Flex';
import { Container } from 'components/Layout';
import { BREAKPOINTS } from 'config/constants';
import TextHeader from 'components/TextHeader';

const WizardContainer = styled(Container)`
  background-color: #f7f8f9;
  min-height: 100vh;
  padding-top: 1.5rem;

  @media screen and (max-width: ${BREAKPOINTS.SM}px) {
    padding-top: 1rem;
  }
`;

const WizardContent = styled.div`
  max-width: 52.5rem;
  width: 100%;
`;

const WizardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 4rem;
  @media screen and (max-width: ${BREAKPOINTS.SM}px) {
    margin-bottom: 2rem;
  }
`;

const WizardSubtitle = styled.p`
  font-size: 1.8rem;
`;

const Wizard = ({ children }) => <WizardContainer>{children}</WizardContainer>;

Wizard.Content = ({ children }) => (
  <Flex justify="center">
    <WizardContent>{children}</WizardContent>
  </Flex>
);

Wizard.Content.Title = ({ children, 'data-testid': testId }) => (
  <TextHeader
    type={TextHeader.TYPES.XLARGE}
    style={{ marginBottom: '0.3rem' }}
    weight={TextHeader.WEIGHTS.HEAVY}
    data-testid={testId}
  >
    {children}
  </TextHeader>
);

Wizard.Content.Subtitle = ({ children, 'data-testid': testId }) => (
  <WizardSubtitle data-testid={testId}>{children}</WizardSubtitle>
);

Wizard.Header = ({ children }) => <WizardHeader>{children}</WizardHeader>;

export default Wizard;
